import type { paths } from '@orlikfy/api-interfaces';

export type { MyGamesDto, MyGamesPlayerDto } from '@orlikfy/api-interfaces';

// GET /my-games
export const GET_MY_GAMES_PATH = '/my-games' as const satisfies keyof paths;
type GetMyGamesOperation = paths[typeof GET_MY_GAMES_PATH]['get'];
export type GetMyGamesResponse = GetMyGamesOperation['responses']['200']['content']['application/json'];
